
    <div class="row" style="margin-top: 150px;">
        <div class="medium-12 column">
            <p>&nbsp;</p>
            <p style="text-align: center;"><img class="alignnone wp-image-1218"
                    src="assets/images/check-square-1-300x261.png" alt="check-square" width="80" height="70"
                    srcset="assets/images/check-square-1-300x261.png 300w, assets/images/check-square-1.png 588w"
                    sizes="(max-width: 80px) 100vw, 80px" /></p>
            <p style="text-align: center;">درخواست شما ثبت گردید.</p>
            <p style="text-align: center;">نتیجه در اسرع وقت به اطلاع شما خواهد رسید.</p>
            <p style="text-align: center;">با تشکر.</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
        </div>
    </div>